import { render, staticRenderFns } from "./SmallMemberItem.vue?vue&type=template&id=1cc737bb&scoped=true&"
import script from "./SmallMemberItem.vue?vue&type=script&lang=js&"
export * from "./SmallMemberItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc737bb",
  null
  
)

export default component.exports